import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=5df91d5f&scoped=true"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=5df91d5f&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df91d5f",
  null
  
)

export default component.exports